import axios from "axios";
import { BASEURL } from "../../baseUrl";
import { toast } from "react-toastify";

export const ADD_DOCTOR = 'ADD_DOCTOR';
export const GET_DOCTOR = 'GET_DOCTOR';
export const DELETE_DOCTOR = 'DELETE_DOCTOR';
export const SEARCH_DOCTOR = 'SEARCH_DOCTOR';
export const UPDATE_DOCTOR = 'UPDATE_DOCTOR';
export const ADD_BRANCH = 'ADD_BRANCH';
export const GET_BRANCH = 'GET_BRANCH';
export const SEARCH_BRANCH = 'SEARCH_BRANCH';
export const UPDATE_BRANCH = 'UPDATE_BRANCH';
export const DELETE_BRANCH = 'DELETE_BRANCH';
export const ADD_COUNSELOR = 'ADD_COUNSELOR';
export const GET_COUNSELOR = 'GET_COUNSELOR';
export const SEARCH_COUNSELOR = 'SEARCH_COUNSELOR';
export const UPDATE_COUNSELOR = 'UPDATE_COUNSELOR';
export const DELETE_COUNSELOR = 'DELETE_COUNSELOR';
export const ADMIN_USER = 'ADMIN_USER';
export const ADMIN_GET = 'ADMIN_GET';
export const ADMIN_UPDATE = 'ADMIN_UPDATE';
export const ADMIN_DELETE = 'ADMIN_DELETE';
export const ADMIN_SEARCH = 'ADMIN_SEARCH';
export const REQUEST_CHANGE_PASSWORD = 'REQUEST_CHANGE_PASSWORD';
export const VERIFY_OTP = 'VERIFY_OTP';

const addDoctorAction = (payload) => ({ type: ADD_DOCTOR, payload: payload });
const getDoctorAction = (payload) => ({ type: GET_DOCTOR, payload: payload });
const deleteDocterAction = (payload) => ({ type: DELETE_DOCTOR, payload: payload });
const searchDocterAction = (payload) => ({ type: SEARCH_DOCTOR, payload: payload });
const updateDocterAction = (payload) => ({ type: UPDATE_DOCTOR, payload: payload });
const addBranchAction = (payload) => ({ type: ADD_BRANCH, payload: payload });
const getBranchAction = (payload) => ({ type: GET_BRANCH, payload: payload });
const searchBranchAction = (payload) => ({ type: SEARCH_BRANCH, payload: payload });
const updateBranchAction = (payload) => ({ type: UPDATE_BRANCH, payload: payload });
const deleteBranchAction = (payload) => ({ type: DELETE_BRANCH, payload: payload });
const addCounselorAction = (payload) => ({ type: ADD_COUNSELOR, payload: payload });
const getCounselorAction = (payload) => ({ type: GET_COUNSELOR, payload: payload });
const searchCounselorAction = (payload) => ({ type: SEARCH_COUNSELOR, payload: payload });
const updateCounselorAction = (payload) => ({ type: UPDATE_COUNSELOR, payload: payload });
const deleteCounselorAction = (payload) => ({ type: DELETE_COUNSELOR, payload: payload });
const adminUserAction = (payload) => ({ type: ADMIN_USER, payload: payload });
const adminGetAction = (payload) => ({ type: ADMIN_GET, payload: payload });
const adminUpdateAction = (payload) => ({ type: ADMIN_UPDATE, payload: payload });
const adminDeleteAction = (payload) => ({ type: ADMIN_DELETE, payload: payload });
const adminSearchAction = (payload) => ({ type: ADMIN_SEARCH, payload: payload });
const requestChangePasswordAction = (payload) => ({ type: REQUEST_CHANGE_PASSWORD, payload: payload });
const verifyOtpAction = (payload) => ({ type: VERIFY_OTP, payload: payload });

export const addAdmin = (payload, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/auth/register`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Add Admin User successfully')
                dispatch(adminUserAction(res));
                dispatch(getAdmin(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminUserAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getAdmin = (limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/auth/ViewAuth?limit=${limits.limit}&page=${limits.page}`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(adminGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(adminGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchAdmin = (queryParams) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')

            await axios.get(`${BASEURL}/auth/searchAuth?limit=10&${queryParams}`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(adminSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(adminSearchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateAdmin = (payload, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')

            await axios.put(`${BASEURL}/auth/UpdateAuth/${payload.authId}`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Update Auth successfully')
                dispatch(adminUpdateAction(res));
                dispatch(getAdmin(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteAdmin = (problemId, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')

            await axios.delete(`${BASEURL}/auth/DeleteAuth/${problemId}`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Delete Auth successfully')
                dispatch(adminDeleteAction(res));
                dispatch(getAdmin(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addDoctor = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerDoctor`, payload).then(((res) => {
                toast.success('Add Doctor successfully')
                dispatch(addDoctorAction(res));
                dispatch(getDoctor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addDoctorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getDoctor = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllDoctor?limit=10&page=${payload.page}`).then(((res) => {
                dispatch(getDoctorAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getDoctorAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const deleteDoctor = (updateId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteDoctor/${updateId}`).then(((res) => {
                toast.success('Delete Doctor successfully')
                dispatch(deleteDocterAction(res));
                dispatch(getDoctor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteDocterAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const searchDoctor = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchDoctor?limit=10&${queryParams}`).then(((res) => {
                dispatch(searchDocterAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchDocterAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateDoctor = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateDoctor`, payload).then(((res) => {
                toast.success('Update Doctor successfully')
                dispatch(updateDocterAction(res));
                dispatch(getDoctor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateDocterAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addBranch = (payload, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.post(`${BASEURL}/master/addBranch`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Add Branch successfully')
                dispatch(addBranchAction(res));
                dispatch(searchBranch(limits));

                dispatch(getBranch(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addBranchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getBranch = (payload) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/master/getAllBranches?limit=${payload.limit}&page=${payload.page}`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(getBranchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getBranchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchBranch = (queryParams) => {
    
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.get(`${BASEURL}/master/searchBranch?${queryParams}`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                dispatch(searchBranchAction(res));
        
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchBranchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateBranch = (payload, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.put(`${BASEURL}/master/updateBranch`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Update Branch successfully')
                dispatch(updateBranchAction(res));
                dispatch(searchBranch(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateBranchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteBranch = (updateId, limits) => {
    return async (dispatch) => {
        try {
            const token = localStorage.getItem('token')
            await axios.delete(`${BASEURL}/master/deleteBranch/${updateId}`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            }).then(((res) => {
                toast.success('Delete Branch successfully')
                dispatch(deleteBranchAction(res));
                dispatch(searchBranch(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteBranchAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addCounselor = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/addCounselor`, payload).then(((res) => {
                toast.success('Add Counselor successfully')
                dispatch(addCounselorAction(res));
                dispatch(getCounselor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addCounselorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getCounselor = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllCounselors?limit=10&page=${payload.page}`).then(((res) => {
                dispatch(getCounselorAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getCounselorAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const searchCounselor = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchCounselor?limit=10&${queryParams}`).then(((res) => {
                dispatch(searchCounselorAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(searchCounselorAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateCounselor = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateCounselor`, payload).then(((res) => {
                toast.success('Update Counselor successfully')
                dispatch(updateCounselorAction(res));
                dispatch(getCounselor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateCounselorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteCounselor = (updateId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteCounselor/${updateId}`).then(((res) => {
                toast.success('Delete Counselor successfully')
                dispatch(deleteCounselorAction(res));
                dispatch(getCounselor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteCounselorAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const requestChangePassword = (payload) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        try {
            const res = await axios.post(`${BASEURL}/subAdmin/request-change-password`, payload, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            });
            toast.success('Request Change Password successfully');
            dispatch(requestChangePasswordAction(res));
            console.log("res>>>", res);
            return res; // Return the full Axios response
        } catch (error) {
            console.log("Error", error);
            const errorResponse = error?.response || { status: 500, data: { message: error.message } };
            toast.error(errorResponse?.data?.message || 'An error occurred');
            dispatch(requestChangePasswordAction(errorResponse));
            return errorResponse; // Return the error response or a fallback
        }
    };
};

export const verifyOtp = (payload) => {
    return async (dispatch) => {
        const token = localStorage.getItem('token');
        try {
            const response = await axios.post(`${BASEURL}/subAdmin/verify-otp`, payload, {
                headers: {
                    authorization: `Bearer ${token}`,
                },
            });
            dispatch(verifyOtpAction(response));
            toast.success('OTP verified successfully');
            return response; // Return the response for the .then block
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred during OTP verification';
            toast.error(errorMessage);
            dispatch(verifyOtpAction(error?.response));
            throw error; // Re-throw the error for the .catch block in the component
        }
    };
};